import { ImageDataLike } from 'gatsby-plugin-image';

export enum ALIGN_CONTENT {
  LEFT = 'left',
  RIGHT = 'right',
  CENTRE = 'centre',
}

export interface VideoBackgroundImage {
  description?: string;
  file?: {
    url?: string;
    contentType?: string;
  };
}

export interface SingleCtaBlockProps {
  title?: string;
  showWhiteBox?: boolean;
  useLightText?: boolean;
  content?: any; // TODO: THis will need to be updated with types from the Rich text block
  backgroundColor?: string;
  backgroundVideoUrl?: string;
  videoBackgroundImage?: VideoBackgroundImage;
  gatsbyImageData: ImageDataLike;
  gatsbyMobileImageData: ImageDataLike;
  format?: string;
  mobileFormat?: string;
  imageSrc?: string;
  mobileImageSrc?: string;
  imageAlt?: string;
  alignment: ALIGN_CONTENT;
  linkOnePath?: string;
  linkOneText?: string;
  isLinkOneExternal?: boolean;
  linkTwoPath?: string;
  linkTwoText?: string;
  isLinkTwoExternal?: boolean;
}

export interface BackgroundProps {
  bgColor?: string;
}

export interface ContentProps {
  alignment: ALIGN_CONTENT;
  showWhiteBox?: boolean;
  useLightText?: boolean;
}
